<i18n src="./resources/locales.json"></i18n>
<i18n src="../../../../mixins/ecs-time-formatter/resources/locales.json"></i18n>

<template>
  <div v-show="!maxHistory" class="load-more">
    <div class="message">
      {{ $t('message') }}
      <div class="since">{{ since }}</div>
    </div>
    <v-btn small plain :disabled="isLoading" @click="loadMore">
      <v-progress-circular v-show="isLoading" :width="2" :size="20" color="primary" indeterminate />
      <span v-show="!isLoading">
        {{ $t('loadMoreBtn') }}
      </span>
    </v-btn>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';
import EcsTimeFormatter from '@/mixins/ecs-time-formatter/EcsTimeFormatter';

export default {
  name: 'SideBarLoadMoreBtn',

  mixins: [EcsTimeFormatter],

  data() {
    return {
      isLoading: false
    };
  },

  computed: {
    ...mapGetters('INTERACTIONS', ['historicalInteractionsSince']),

    ...mapGetters('SETTINGS', ['currentUserSettings']),

    maxHistory() {
      const { preferencesSettings } = this.currentUserSettings;
      const diff = moment().diff(moment(this.historicalInteractionsSince), 'days');
      const max = preferencesSettings.interactionHistoryPeriod / 24;

      return diff >= max;
    },

    since() {
      return this.fromNow(this.historicalInteractionsSince, 'UTC');
    }
  },

  methods: {
    ...mapActions('INTERACTIONS', ['requestAgentInteractionHistory']),

    loadMore() {
      this.isLoading = true;
      this.requestAgentInteractionHistory().finally(() => {
        this.isLoading = false;
      });
    }
  }
};
</script>

<style lang="scss">
.load-more {
  width: 100%;
  height: 72px;
  padding: 0 32px;
  font-size: 12px;
  text-align: center;

  .message {
    opacity: 0.5;
    padding-bottom: 4px;
  }

  .since {
    font-weight: bold;
  }

  .v-btn {
    border-radius: 6px !important;
    height: 24px !important;
    line-height: 24px;
    opacity: 0.75;

    &:hover {
      opacity: 1;
    }
  }
}
</style>
